import React, {useState, useEffect} from "react";
import {FaCheckCircle} from "react-icons/fa";
import AuthLayout from "../../components/Layouts/AuthLayout"
import {CustomerType, RouteNames} from "../../constants";
import LogoText from "../../components/LogoText";
import SignupForm from "../../components/Auth/signupForm";
import {Link} from "react-router-dom";
import SentIcon from "../../assets/icons/sent-icon.png";
import {FiInfo} from "react-icons/fi";
import {getBanks} from "../../redux/selfService/selfServiceSlice";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";

const Login = () => {
    const dispatch = useAppDispatch();
    const { isLoading, isSuccessful, allBanks } = useAppSelector((state) => state?.selfService);
    const [signupStep, setSignupStep] = useState(0);
    const [signupOption, setSignupOption] = useState(CustomerType.TPIN);

    useEffect(()=>{
        dispatch(getBanks());
    }, [])

    const prevStep = () => {
        setSignupStep(signupStep-1)
    }

    const nextStep = () =>{
        setSignupStep(signupStep+1)
    }

    return (
        <AuthLayout>
            <div className="signup">
                <div className="signup_head">
                    {signupStep !== 2 ?
                        <span>Already have an account?</span>
                        : <></>
                    }
                    <Link to={RouteNames.LOGIN} className="ml-4 btn btn-outline">
                        Login
                    </Link>
                </div>
                {signupStep === 0 ?
                    <div className="signup_body">
                        <div>
                            <h1 className="signup_body_head">
                                Sign up to <LogoText/>
                            </h1>
                            <div className="signup_body_text">
                                Select an option below to get started.
                            </div>
                        </div>
                        <div>
                            <div className="customer_type_toggle">
                                <div
                                    className={`toggle_btn toggle_btn_left ${signupOption === CustomerType.RSA ? 'active' : ''}`}
                                    onClick={() => setSignupOption(CustomerType.RSA)}
                                >
                                    New RSA
                                </div>
                                <div
                                    className={`toggle_btn toggle_btn_right ${signupOption === CustomerType.TPIN ? 'active' : ''}`}
                                    onClick={() => setSignupOption(CustomerType.TPIN)}
                                >
                                    TPIN
                                </div>
                            </div>
                            {signupOption === CustomerType.TPIN ?
                                <div className="customer_benefits">
                                    <div className="customer_benefits_head">
                                        Sign up as TPIN customer to
                                    </div>
                                    <ul className="customer_benefits_items">
                                        <li className="customer_benefits_item">
                                    <span className="text-xl text-primaryDark mr-4">
                                        <FaCheckCircle/>
                                    </span>
                                            Enjoy good and competitive returns on your pension investment
                                        </li>
                                        <li className="customer_benefits_item">
                                    <span className="text-xl text-primaryDark mr-4">
                                        <FaCheckCircle/>
                                    </span>
                                            Enjoy ease of account access
                                        </li>
                                        <li className="customer_benefits_item">
                                    <span className="text-xl text-primaryDark mr-4">
                                        <FaCheckCircle/>
                                    </span>
                                            Instant access to account statements
                                        </li>
                                    </ul>
                                </div>
                                :
                                <div className="customer_benefits">
                                    <div className="customer_benefits_head">
                                        Sign up as RSA customer to
                                    </div>
                                    <ul className="customer_benefits_items">
                                        <li className="customer_benefits_item">
                                    <span className="text-xl text-primaryDark mr-4">
                                        <FaCheckCircle/>
                                    </span>
                                            Enjoy good and competitive returns on your pension investment
                                        </li>
                                        <li className="customer_benefits_item">
                                    <span className="text-xl text-primaryDark mr-4">
                                        <FaCheckCircle/>
                                    </span>
                                            Enjoy ease of account access
                                        </li>
                                        <li className="customer_benefits_item">
                                    <span className="text-xl text-primaryDark mr-4">
                                        <FaCheckCircle/>
                                    </span>
                                            Instant access to account statements
                                        </li>
                                    </ul>
                                </div>
                            }
                        </div>
                        <button className="btn btn-primary btn-primary-full" onClick={nextStep}>
                            Next
                        </button>
                    </div>
                    : <></>
                }
                {
                    signupStep === 1 ?
                        <SignupForm
                            prevPage={prevStep}
                            nextPage={nextStep}
                            selectedCustomerType={signupOption}
                        />
                        : <div className="signup_footer">
                            PENSMART APPLICATION - VERSION 2.0
                        </div>
                }
                {
                    signupStep === 2 ?
                        <div className="login forget-password2">
                            <div className="login_form">

                            <div>
                                <img src={SentIcon} alt=""/>
                            </div>
                            <h2 className="login_form_head">
                                Check your inbox and confirm your email address
                            </h2>
                            <div className="login_form_text">
                                We've sent a confirmation email to
                                <span className="font-bold"> your email</span>.
                            </div>
                            <div className="info_box">
                                <div className="info_box_head">
                                    <span className="text-2xl"><FiInfo className="mr-2" /></span>
                                    Didn't receive an email?
                                </div>
                                <div className="info_box_text">
                                    If you can't find the email in your inbox or spam folder, please click below and we will send you a new one.
                                </div>
                            </div>
                            <div>
                                <button className="btn btn-primary-alt">
                                    Resend Email
                                </button>
                            </div>
                        </div>
                        </div>
                        : <></>
                }
            </div>
        </AuthLayout>
    );
}

export default Login;